/* eslint-disable import/prefer-default-export */
import dayjs from 'utils/dayjs';

import {
  FIELD_CONTACT,
  FIELD_END,
  FIELD_ID,
  FIELD_MODEL,
  FIELD_MODEL_ID,
  FIELD_NOTES,
  FIELD_SYNC_WORK_ORDER_REASON,
  FIELD_NOTIFY_CUSTOMER,
  FIELD_NOTIFY_TECH,
  FIELD_REMINDERS,
  FIELD_SITE,
  FIELD_SITE_ID,
  FIELD_SMS_REMINDER_ENABLED,
  FIELD_START,
  FIELD_SYSTEM,
  FIELD_TECHNICIAN_USERS,
  FIELD_TITLE,
} from '../constants/fields';
import { getModelEventColor } from './colors';

export function transformApiEvent(data) {
  return {
    [FIELD_ID]: data.id,
    [FIELD_MODEL]: data.model_name.replace(' ', ''),
    [FIELD_MODEL_ID]: data.model_id,
    [FIELD_START]: dayjs.utc(data.start).format(),
    [FIELD_END]: dayjs.utc(data.end).format(),
    [FIELD_SYSTEM]: data.subtype,
    [FIELD_NOTES]: data.notes,
    [FIELD_SYNC_WORK_ORDER_REASON]: Boolean(data.settings?.sync_work_order_reason),
    [FIELD_TITLE]: data.title,
    [FIELD_TECHNICIAN_USERS]: data.users.map(({ id }) => id),
    [FIELD_NOTIFY_CUSTOMER]: Boolean(data.settings?.notify_customer),
    [FIELD_NOTIFY_TECH]: Boolean(data.settings?.notify_tech),
    [FIELD_SMS_REMINDER_ENABLED]: Boolean(data.settings?.sms_reminder_enabled),
    [FIELD_REMINDERS]: data.settings?.sms_reminders ?? [],
    [FIELD_SITE_ID]: data.model?.site_id
      ? (parseInt(data.model?.site_id, 10) ?? null)
      : null,
    [FIELD_CONTACT]: data.model?.contact_id
      ? (parseInt(data.model?.contact_id, 10) ?? null)
      : null,
    [FIELD_SITE]: data.model?.site ?? null,
  };
}

export function transformApiUser(data) {
  return {
    id: data.id,
    name: data.name,
    image: data.image,
    availability: data.availability ?? [],
  };
}

export function transformToCalendarEvent(
  { id, title, start, end, model },
  userId,
  primaryMain,
) {
  return {
    id,
    title,
    resource: userId,
    start,
    end,
    color: getModelEventColor(model, primaryMain),
  };
}
